import { useState } from "react";
import SearchIcon from "@mui/icons-material/Search";
import HomeOutlinedIcon from "@mui/icons-material/HomeOutlined";
import MiniDrawer from "../../../components/MiniDrawer/MiniDrawer";
import { useNavigate } from "react-router-dom";
import filterIcon from "../../../Icons/filterIcon.png";
import ExcelExport from "../../../components/ExcelExport/ExcelExportAccounts";
import Doc from '../../../Icons/Doc.jpg'

const AccountsInvoice = () => {

    const [expenseDetailResponse, setExpenseDetailResponse] = useState([''])
    const navigate = useNavigate();

    return (
        <div>
            <div className="app-container-viewLeadDetails">
                <MiniDrawer />
                <div
                    style={{ overflowX: "hidden" }}
                    className="container-fluid container-viewLeadDetails"
                >
                    <div
                        style={{
                            display: "flex",
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginBottom: "1rem",
                        }}
                        className="country-header"
                    >
                        <div>
                            <h1 style={{ fontSize: "24px" }}>
                                <b> Invoice </b> | <HomeOutlinedIcon /> &gt;
                                <a
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate("/Invoice")}
                                >
                                    Accounts & Finance{" "}
                                </a>
                                <span style={{ fontSize: "20px" }}>&gt; Sales Register</span>{" "}
                                <span style={{ fontSize: "20px" }}>
                                    &gt; Invoice
                                </span>
                            </h1>
                        </div>

                    </div>

                    <div>


                        <div className="container-fluid px-3 py-2">
                            <div className='mt-2' style={{ display: "flex", justifyContent: "space-between" }}>
                                <button className="filterButton">
                                    <img src={filterIcon} /> FILTER
                                </button>
                                <div style={{ display: "flex" }}>

                                    <ExcelExport />
                                </div>
                            </div>
                            <hr
                                style={{ marginTop: "20px", padding: "0px", marginBottom: "30px" }}
                            />
                            <div className="expenseList">
                                <h2
                                    className="Venderheading"
                                    style={{
                                        fontSize: "22px",
                                        paddingLeft: "16px",
                                        paddingTop: "7px",
                                    }}
                                >
                                    Invoice
                                </h2>
                                <table style={{ width: "100%" }} className="table_expense">
                                    <thead>
                                        <tr className="expenseListHeading">
                                            <th>S.No.</th>
                                            <th>Lead ID</th>
                                            <th>Date</th>
                                            <th>Customer Name</th>
                                            <th>Contact Number</th>
                                            <th>Service Type</th>
                                            <th>Location</th>
                                            <th>Invoice Number</th>
                                            <th>Debit Amount</th>
                                            <th>Credit Amount</th>
                                            <th>Doc</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {expenseDetailResponse !== null ? (
                                            expenseDetailResponse.map((expense, index) => (
                                                <>
                                                    <tr key={index + 1}>
                                                        <td>01</td>
                                                        <td>Air Freight</td>
                                                        <td>12 Dec 2024</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>₹ 59,999</td>
                                                        <td>₹ 59,999</td>

                                                        <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '17px' }} >

                                                            <img className="text-center" src={Doc} />



                                                        </td>
                                                    </tr>
                                                    <tr key={index + 1}>
                                                        <td>01</td>
                                                        <td>Air Freight</td>
                                                        <td>12 Dec 2024</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>₹ 59,999</td>
                                                        <td>₹ 59,999</td>

                                                        <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '17px' }} >

                                                            <img className="text-center" src={Doc} />



                                                        </td>
                                                    </tr>
                                                    <tr key={index + 1}>
                                                        <td>01</td>
                                                        <td>Air Freight</td>
                                                        <td>12 Dec 2024</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>₹ 59,999</td>
                                                        <td>₹ 59,999</td>

                                                        <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '17px' }} >

                                                            <img className="text-center" src={Doc} />



                                                        </td>
                                                    </tr>
                                                    <tr key={index + 1}>
                                                        <td>01</td>
                                                        <td>Air Freight</td>
                                                        <td>12 Dec 2024</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>₹ 59,999</td>
                                                        <td>₹ 59,999</td>

                                                        <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '17px' }} >

                                                            <img className="text-center" src={Doc} />



                                                        </td>
                                                    </tr>
                                                    <tr key={index + 1}>
                                                        <td>01</td>
                                                        <td>Air Freight</td>
                                                        <td>12 Dec 2024</td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td></td>
                                                        <td>₹ 59,999</td>
                                                        <td>₹ 59,999</td>

                                                        <td style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '17px' }} >

                                                            <img className="text-center" src={Doc} />



                                                        </td>
                                                    </tr>
                                                </>

                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="15">No expenses available</td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <nav
                      aria-label="Page navigation"
                      style={{
                        display: "flex",
                        justifyContent: "flex-end",
                        marginTop: "1rem",
                      }}
                    >
                      <ul className="pagination">
                        <li className="page-item">
                          <a style={{ cursor: "pointer",fontWeight:'bold',color:'#5B489D' }}
                            className="page-link"
                          >
                            Previous
                          </a>
                        </li>
                      
                        <li style={{backgroundColor:'#5B489D'}} className="page-item active">
                          <a style={{backgroundColor:'#5B489D',border:'none'}}  className="page-link">1</a>
                        </li>
                        <li className="page-item">
                          <a style={{ cursor: "pointer",color:'#5B489D' }}
                            className="page-link"
                          >
                            2
                          </a>
                        </li>
                        <li  className="page-item">
                          <a style={{ cursor: "pointer" ,color:'#5B489D',fontWeight:'bold'}}
                            className="page-link"
                          >
                            Next
                          </a>
                        </li>
                      </ul>
                    </nav>
                            </div>
                        </div>
                    </div>
                    {/* ------------------------customer deatil--------------------- */}
                </div>
            </div>
        </div>
    )
}

export default AccountsInvoice;

